module.exports = __webpack_public_path__ + "static/media/awesome-search.8a25da97.mp4";